import React from "react";
import { Container } from "react-bootstrap";
import mail from "../../img/contact-us/mail.svg";
import linkedin from "../../img/contact-us/linkedin.svg";
import instagram from "../../img/contact-us/instagram.svg";
import "./contact.css";

function Contact() {
  return (
    <div className="contact-background">
      <Container className="contact-container">
        <div className="card"></div>
        <div className="content">
          <p className="heading">Contact Us</p>
          <div className="email">
            <img src={mail} alt="" />
            <p>example@email.com</p>
          </div>
          <div className="social-media">
            <img src={linkedin} alt="linkedin" />
            <img src={instagram} alt="instagram" />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Contact;
